
import { Routes, Route } from 'react-router-dom';
import { AdminLayout } from './AdminLayout';
import { DashboardHome } from './DashboardHome';
import { HeroManager } from './HeroManager';
import { PackageManager } from './PackageManager';
import EnhancedPackageManager from './EnhancedPackageManager';
import { ServicesManager } from './ServicesManager';
import { AboutManager } from './AboutManager';
import { CompanyManager } from './CompanyManager';
import { SocialMediaManager } from './SocialMediaManager';
import SocialMediaPostsManager from './SocialMediaPostsManager';
import { MessageViewer } from './MessageViewer';
import EmailSettingsPage from './EmailSettingsPage';
import ReviewsManager from './ReviewsManager';
import { WhyChooseUsManager } from './WhyChooseUsManager';
import AccommodationManager from './AccommodationManager';
import { ContentManager } from './ContentManager';

export function AdminDashboard() {
  return (
    <AdminLayout>
      <Routes>
        <Route index element={<DashboardHome />} />
        <Route path="content" element={<ContentManager />} />
        <Route path="hero" element={<HeroManager />} />
        <Route path="packages" element={<PackageManager />} />
        <Route path="enhanced-packages" element={<EnhancedPackageManager />} />
        <Route path="services" element={<ServicesManager />} />
        <Route path="about" element={<AboutManager />} />
        <Route path="company" element={<CompanyManager />} />
        <Route path="social" element={<SocialMediaManager />} />
        <Route path="social-posts" element={<SocialMediaPostsManager />} />
        <Route path="messages" element={<MessageViewer />} />
        <Route path="email" element={<EmailSettingsPage />} />
        <Route path="reviews" element={<ReviewsManager />} />
        <Route path="why-choose-us" element={<WhyChooseUsManager />} />
        <Route path="accommodations" element={<AccommodationManager />} />
      </Routes>
    </AdminLayout>
  );
}
